import { render } from "./RequestIouBack.vue?vue&type=template&id=fab19768&scoped=true"
import script from "./RequestIouBack.vue?vue&type=script&lang=js"
export * from "./RequestIouBack.vue?vue&type=script&lang=js"

import "./RequestIouBack.vue?vue&type=style&index=0&id=fab19768&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab19768"]])

export default __exports__